<template>
    <v-form>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    v-model="form.code"
                    outlined
                    dense
                    hide-details="auto"
                    label="Code"
                    clearable
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.from"
                    outlined
                    dense
                    hide
                    label="From"
                    clearable
                >
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.to"
                    outlined
                    dense
                    hide
                    label="To"
                    clearable
                >
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.mode"
                    :items="modes"
                    hide-details="auto"
                    outlined
                    dense
                    label="Modes"
                    clearable
                >

                </v-autocomplete>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.supplier_id"
                    outlined
                    dense
                    hide-details="auto"
                    label="Supplier"
                    clearable
                    @update:search-input="searchSuppliers"
                    item-text="display_name"
                    item-value="id"
                    :items="suppliers"
                >

                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.created_by_id"
                    outlined
                    dense
                    hide-details="auto"
                    label="Created By"
                    clearable
                    @update:search-input="searchUsers"
                    item-text="name"
                    item-value="id"
                    :items="users"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select
                    outlined
                    dense
                    hide-details="auto"
                    label="State"
                    :items="states"
                    v-model="form.state"
                >

                </v-select>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PDatePicker from "./../../components/common/PDatePicker";
import payament from "./../../services/purchase/payment"
import userAPI from './../../services/purchase/user'

export default {
    name: "PurchasePaymentListSearch",
    components: {
        PDatePicker
    },
    data() {
        return {
            form: {
                code: null,
                from: null,
                to: null,
                supplier_id: null,
                state: null,
                mode: null,
                created_by_id: null
            },
            users: [],
            usersLoading: false,
            states: []
        }
    },
    computed: {
        ...mapGetters({
            paymentModes: "purchase/paymentMode/list",
            params: "purchase/payment/params",
            suppliers: "purchase/supplier/list",
            loading: "purchase/supplier/loading",
        }),
        modes() {
            return Array.from(new Set([{value: null, text: "All"}, ...this.paymentModes]))
        }
    },
    methods: {
        ...mapActions({
            fetchPaymentModes: "purchase/paymentMode/index",
            updateParams: "purchase/payment/updateParams",
            searchSuppliers: "purchase/supplier/search"
        }),
        submit() {
            this.updateParams(this.form)
        },
        searchUsers(query) {
            this.usersLoading = true;
            userAPI.search(query).then(response => {
                this.users = Array.from(new Set([...this.users, ...response.data]));
            }).finally(() => {
                this.usersLoading = false;
            })
        }
    },
    mounted() {
        this.fetchPaymentModes();
        this.form = {...this.params}
        payament.states().then(response => this.states = response.data)
    }
} 
</script>

<style>

</style>